// @ts-check
import { useCallback, useEffect, useState } from 'react';
import useEscape from '../useEscape';
import useClickOutside from '../useClickOutside';
import useScroll from '../useScroll';

const useToggle = (defaultActive = false, deactivateOn = {}, onToggle = null) => {
  const [active, setActive] = useState(defaultActive);
  const toggle = useCallback(a => setActive(typeof a === 'boolean' ? a : !active), [active]);
  const deactivate = useCallback(() => setActive(false));
  const elementRef = useClickOutside(deactivate, !deactivateOn.clickOutside);

  useEscape(deactivate, !deactivateOn.escape);
  useScroll(deactivate, 150, !deactivateOn.scroll);

  useEffect(() => {
    if (typeof onToggle === 'function') {
      onToggle(active);
    }
  }, [active]);

  return [active, toggle, elementRef];
};

/* @component */
export default useToggle;
